<div class='background-box-charts-lines'>

{{#each key_arr as gradation}}

{{#if gradation != 'missing_data' }}
<div class='flex-outside'>

	<p class='key-text-chart float-left'>{{key_label[gradation]}}</p>
	<div class='svg-box float-left' style='border-top: 2px solid {{line_colors[gradation]}}'>
	</div>
</div>


{{else}}
<div class='flex-outside'>
<div class='key-box-chart'>
	<p class='key-text-chart'>{{key_label[gradation]}}</p>
<div class='key-grade-chart {{gradation}}'>

</div>
</div>
</div>
{{/if}}
{{/each}}

</div>
<style>

.float-left {
	float: left;
}

.svg-box {
	width: 15px; margin-top: 9px;
}

.flex-outside {
	/*display: flex;*/
	margin-right: 22px;
}
svg {
	width: 20px;
	height: 20px;
}

line {
	stroke-width: 2;
}

.black_man {
	border-top: #c05303 solid 3px;
}

.white_man {
	border-top: #507892 solid 3px;
}

.black_woman {
	border-top: #dc8655 solid 3px;
}

.white_woman {
	border-top: #a7b9c8 solid 3px;
}

.missing_data {
	background-color: #eaeaea;
}

.background-box-charts-lines {
	/*background-color: rgba(255, 255, 255, .8);*/
	/*padding: 10px;*/
	/*width: 111px;*/
	/*height: 66px;*/
	display: flex;
	justify-content: flex-start;;
	align-content: center;
	flex-wrap: wrap;
	max-width: 620px;
	margin: 0 auto;
}

.key-sub-head {
	margin-left: 20px;
	font-weight: 900;
}

.key-text-chart {
	/*margin-top: 10px;*/
	/*margin-left: 28px;*/
	margin: 0 5px 0 0;
	font-family: 'Guardian Text Sans Web';
	font-size: 14px;
	font-weight: 900;
}

.key-box-chart {
	/*width: 200px;*/
	height: 15px;
	display: flex;
	margin-bottom: 10px;
	/*width: 100%;*/
}

.key-grade-chart {
	width: 15px;
	height: 100%;
	margin-top: 2px;
}

</style>

<script>
const key_label = {
	black_man: 'Black men',
	white_man: 'White men',
	black_woman: 'Black women',
	white_woman: 'White women',
	missing_data: 'Missing or unconfirmed data'
}

const line_colors = {
	black_man: '#c05303',

	white_man: '#507892',

	black_woman: '#dc8655',

	white_woman: '#a7b9c8'
};

const key_arr = ['black_man', 'white_man', 'black_woman', 'white_woman', 'missing_data']
const statLookup = ["", "", "", "below 100% poverty line", "without high school degree", "black"];
export default {
	data () {
		return {
			key_arr,
			key_label,
			statLookup,
			line_colors
		};
	}
};
</script>
